import { PageHero } from "./About";

const CONTENT = {
  privacy: { kicker: "Legal", title: "Privacy Policy", body: [
    "This Privacy Policy explains how Homio collects, uses and protects your personal data when you use our platform.",
    "Data we collect: When you submit an enquiry or contact form we collect your name, email, phone number and any message you provide, together with technical data such as your IP address and browser type.",
    "How we use it: We use your details to process your enquiry and to refer it to the relevant property partner so they can respond to you directly. We only send marketing communications where you have separately opted in.",
    "Sharing: We share necessary enquiry details with the relevant estate agent, letting agency or property partner. We do not sell your personal data.",
    "Your rights: You may request access to, correction of, or deletion of your personal data at any time by contacting us.",
  ]},
  terms: { kicker: "Legal", title: "Terms & Conditions", body: [
    "These Terms govern your use of the Homio platform.",
    "Homio operates as an introducer and referral platform. We advertise properties supplied by third-party agencies and partners and refer enquiries to them.",
    "Property information is provided by third parties. While we take care to present accurate listings, availability, prices, measurements, images, tenure and descriptions are not guaranteed and should be independently verified.",
    "Homio does not sell, let, manage, value or negotiate properties and is not responsible for any transaction between you and a property partner.",
    "By using this website you agree to use it lawfully and not to misuse the enquiry or contact forms.",
  ]},
  cookies: { kicker: "Legal", title: "Cookie Policy", body: [
    "This Cookie Policy explains how Homio uses cookies and similar technologies.",
    "Necessary cookies are required for the website to function and cannot be switched off. Analytics, marketing and preference cookies are optional and are only used with your consent.",
    "You can manage your cookie preferences at any time using the 'Cookie settings' link in the footer.",
    "Non-essential analytics and marketing scripts are not loaded until you have given consent.",
  ]},
  disclaimer: { kicker: "Legal", title: "Website Disclaimer", body: [
    "The content on this website is provided for general information only and does not constitute legal, financial, mortgage, investment, surveying or property advice.",
    "Homio acts as a referral and introduction platform. Property details are supplied by third-party agencies and partners and should be independently verified.",
    "Homio does not guarantee that any property remains available. The relevant property partner is responsible for direct customer communication and transaction handling.",
    "Homio may receive a referral fee or commission where an enquiry results in a successful transaction.",
  ]},
  complaints: { kicker: "Legal", title: "Complaints Procedure", body: [
    "Homio is committed to providing a high-quality service. If something has gone wrong, we want to hear about it.",
    "How to complain: Please contact us via our Contact page selecting 'Complaint' as the enquiry type, providing as much detail as possible.",
    "What happens next: We will acknowledge your complaint and aim to provide a full response as soon as reasonably practicable.",
    "Please note that complaints relating to a specific transaction or property should also be raised directly with the relevant property partner, who is responsible for that transaction.",
  ]},
};

export default function Legal({ page }) {
  const c = CONTENT[page] || CONTENT.privacy;
  return (
    <div>
      <PageHero kicker={c.kicker} title={c.title} />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-800 mb-8" data-testid="legal-draft-notice">
          <strong>Draft notice:</strong> This is placeholder legal copy provided as a starting point. It must be reviewed and customised by a qualified professional before launch.
        </div>
        <div className="prose prose-lg max-w-none text-[#111827]/80">
          {c.body.map((para, i) => <p key={i}>{para}</p>)}
        </div>
      </div>
    </div>
  );
}
